const React = require("react");

exports.onRenderBody = ({ setHeadComponents }) => { 
    setHeadComponents([ 
        <script key="gosquared" dangerouslySetInnerHTML={{ 
            __html: `  !function(g,s,q,r,d){r=g[r]=g[r]||function(){(r.q=r.q||[]).push(arguments)};
            d=s.createElement(q);d.src='https://d1l6p2sc9645hc.cloudfront.net/gosquared.js';q=
            s.getElementsByTagName(q)[0];q.parentNode.insertBefore(d,q)}(window,document
            ,'script','_gs');

            _gs('GSN-593904-M');
            _gs('set', 'anonymizeIP', true); `, 
        }} 
        />, 
    ]); 
};